import * as styles from "../styles/OtherKeySites.module.scss";
import { IKeySitesData } from "../services/TileService";
import { useKeySitesData } from "../hooks/useTileData";
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";

// MSAL imports
import { useMsal } from "@azure/msal-react";

// Material-UI imports
import { theme } from "../styles/theme";
import { Card, CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";
import { Constants } from "../Constants";

const OtherKeySites = () => {
  const { instance, inProgress } = useMsal();
  const { keySitesData: tileData, isLoading } = useKeySitesData(inProgress, instance);
  const { t } = useTranslation();

  return (
    <Box className={styles.OtherKeySites}>
      <Typography variant="h5" className={styles.title}>
        {t(Constants.translationKeys.other_key_sites_title)}
      </Typography>
      {isLoading && <CircularProgress color="primary" />}
      {!isLoading && tileData && (
        <Swiper
          spaceBetween={16}
          slidesPerView="auto"
          freeMode={{ enabled: true, sticky: true }}
          modules={[FreeMode]}
          className={styles.swiper}
        >
          {tileData.map((item: IKeySitesData, index: number) => {
            return (
              <SwiperSlide 
              className={styles.slide}
              >
                <Card
                  key={`other_sites_tile_${index}`}
                  className={styles.card}
                  component={Link}
                  href={isMobile && item.appUrl ? item.appUrl : item.webUrl}
                  target="_blank"
                  data-parentid="other-key-sites"
                  data-id={`other_sites_tile_${item.name}`}
                >
                  <img
                    src={`/icons/key-sites/${item.name}.png`}
                    alt={item.title}
                  />
                  <Box className={styles.contentContainer}>
                    <Box className={styles.keySiteTitle}>
                      <Typography
                        variant="date"
                        fontWeight={700}
                        className={styles.itemTitle}
                      >
                        {t(`other_key_site_tile_title_${item.name}`)}
                      </Typography>
                      <ArrowForwardIcon
                        className={styles.icon}
                        color="primary"
                      />
                    </Box>
                    <Typography
                      variant="date"
                      color={theme.palette.text.secondary}
                    >
                      {t(`other_key_site_tile_subtitle_${item.name}`)}
                    </Typography>
                  </Box>
                </Card>
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </Box>
  );
};

export default OtherKeySites;
